// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Uuid from "uuid";

let Discount = {};

function makeDiscounted(value, amount, kind) {
  if (kind === "PERCENT") {
    return value - value * amount / 100;
  } else {
    return value - amount;
  }
}

let ProductPrice = {
  makeDiscounted: makeDiscounted
};

function make(id, cku, name, description, stockKeepingUnit, purchasePrice, bulkUnit, retailPricesData, selectedPriceName) {
  let prices = retailPricesData.map(param => ({
    name: param[0],
    value: param[1]
  }));
  return {
    id: id,
    cku: cku,
    name: name,
    description: description,
    stockKeepingUnit: stockKeepingUnit,
    purchasePrice: purchasePrice,
    bulkUnit: bulkUnit,
    retailPrices: prices.some(param => param.name === selectedPriceName) ? prices : undefined,
    discount: {
      id: Uuid.v4(),
      amount: 0,
      kind: "CURRENCY"
    }
  };
}

function isValid(discountedProduct, selectedPriceName) {
  let match = discountedProduct.discount;
  let match$1 = discountedProduct.retailPrices;
  let retailPriceValue;
  if (match$1 !== undefined && selectedPriceName !== undefined) {
    let match$2 = match$1.find(price => price.name === selectedPriceName);
    retailPriceValue = match$2 !== undefined ? match$2.value : undefined;
  } else {
    retailPriceValue = undefined;
  }
  if (retailPriceValue === undefined) {
    return false;
  }
  let discountedValue = makeDiscounted(retailPriceValue, match.amount, match.kind);
  if (discountedValue < retailPriceValue) {
    return discountedValue >= 0;
  } else {
    return false;
  }
}

export {
  Discount,
  ProductPrice,
  make,
  isValid,
}
/* uuid Not a pure module */
